

export const AppTrPlugin = {
    install : function (Vue, options) {
        // 1. add global method or property
        // Vue.myGlobalMethod = function () {
        //     // some logic ...
        // }N

        // 2. add a global asset
        // Vue.directive('my-directive', {
        //     bind (el, binding, vnode, oldVnode) {
        //         // some logic ...
        //     }
        //     ...
        // })

        // 3. inject some component options

        // 4. add an instance method
        /**
         * @param key {String}
         * @param defaultTranslation {String}
         * @param args {...}
         */
        Vue.prototype.$tr = function(key, defaultTranslation, args) {
            return AppTranslations.translate(...arguments);
        }
    }
}